// extracted by mini-css-extract-plugin
export default {"Container":"Offers_Container__QQDtv"};